import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import HeroVideo from '../../containers/hero-video';

import PhotoInfo from '../../containers/photo-info';
import RelatedVideo from '../../containers/related-video';

const HeroVideoBlock = props => <HeroVideo {...props} />;
HeroVideoBlock.displayName = 'HeroVideo';

export default withDynamicComponents({
  componentWhitelist: [
    PhotoInfo,
    RelatedVideo,
  ],
  mapInputToOutput: [
    ['photoInfo', 'photoInfo'],
    ['relatedVideo', 'relatedVideo'],
  ],
})(HeroVideoBlock);



// WEBPACK FOOTER //
// ./src/blocks/hero-video/index.jsx